module.exports = __webpack_public_path__ + "54cf98f5/img/search-filter-icon.c4751a52.svg";